import {
  amber,
  blue,
  deepOrange,
  green,
  lightBlue,
  purple,
  red,
  yellow,
  cyan
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ContentPasteOffRoundedIcon from "@mui/icons-material/ContentPasteOffRounded";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "../GenericHomePage/GenericHomePage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import StarIcon from "@mui/icons-material/Star";
import FileCopyIcon from '@mui/icons-material/FileCopy';
const RolesHomePage = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    {
      textBeside: "Pending Orders", // Label displayed next to the icon
      icon: AssignmentRoundedIcon, // MUI Icon component
      iconColor: amber[700], // Icon color
      iconFontSize: theme.spacing(10), // Icon size
      boxbackgroundColor: amber[100], // Box background color
      onClick: () => navigate(DefaultRoutes.pendingOrders), // Action on click
    },
    {
      textBeside: "Released Orders",
      icon: AssignmentTurnedInRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[50],
      onClick: () => navigate(DefaultRoutes.releasedOrders),
    },
    {
      textBeside: "Canceled Orders",
      icon: ContentPasteOffRoundedIcon,
      iconColor: red[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: red[50],
      onClick: () => navigate(DefaultRoutes.canceledOrders),
    },
    {
      textBeside: "Starred Orders",
      icon: StarIcon,
      iconColor: yellow[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: yellow[50],
      size: 4,
      onClick: () => navigate(DefaultRoutes.starredOrders),
    },
    {
      textBeside: "Clearance Dashboard",
      icon: DashboardIcon,
      iconColor: lightBlue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: lightBlue[50],
      size: 4,
      onClick: () => navigate(DefaultRoutes.clearanceDashboard),
    },
    {
      textBeside: "MSDS Directory",
      icon: FileCopyIcon,
      iconColor: cyan[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: cyan[50],
      onClick: () => navigate(DefaultRoutes.msdsdirectory),
      size: 4,
    },
  ];
  return <GenericHomePage sectionsBox={sectionsBox} />;
};
export default RolesHomePage;
